/**
  * 部门 接口的统一出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const noteConfig = {
    // 修改
    edit(params) {
        return axios.post(api + 'noteConfig/edit', qs.stringify(params))
    },
    // 详情
    detail(params) {
        return axios.get(api + 'noteConfig/detail', { params: params })
    },

}

// 导出接口
export default noteConfig